define( [
	"./arr"
], function( arr ) {

"use strict";

return arr.pop;

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/pop.js
// module id = 1825
// module chunks = 0